import * as c from '../constants/FormConstants'

export const annihilateField =
  ({ formName, fieldName }) =>
  dispatch =>
    dispatch({ type: c.ANNIHILATE_FIELD, payload: { formName, fieldName } })
